import { t } from '../../i18n/init.js';
import type { ComponentInstance } from '../component.js';
import { setText } from '../dom-helpers.js';

// Idle is a transient state (orchestrator dispatches PARSE_URL immediately).
// We render a minimal label so the user never sees a blank screen if it does
// somehow surface for a moment.
export function mountIdle(root: HTMLElement): ComponentInstance<unknown> {
  root.innerHTML = '';

  const wrap = document.createElement('div');
  wrap.setAttribute('role', 'status');
  wrap.style.cssText =
    'position:fixed;inset:0;display:flex;align-items:center;justify-content:center;color:#71717a;font-family:system-ui,sans-serif;font-size:0.875rem';
  setText(wrap, t('viewer.idle.waiting'));
  root.appendChild(wrap);

  return {
    update() {
      // No props; static.
    },
    cleanup() {
      wrap.remove();
    },
  };
}
